import type {
    FeesData,
    TertiaryData,
} from "../../service/forms/config-generics/institution";
import type { SchoolData } from "../../service/forms/config-generics/school";
import type { SVGProcessData, SVGSourceData } from "./svg-config";

export function getInstitutionSVGLines({
    course,
    courseLength,
    highestQualification,
    institution,
    institutionAddress,
    status,
    subjects,
    qualifications,
    yearOfStudy,
}: TertiaryData) {
    return [
        { heading: "Institution" },
        { label: "Institution", text: institution },
        { label: "Address", text: institutionAddress },
        { heading: "Course" },
        { label: "Course", text: course },
        { label: "Length", text: courseLength },
        { label: "Year", text: yearOfStudy },
        { label: "Subjects", text: subjects },
        { label: "Status", text: status },
        { heading: "Qualifications" },
        { label: "Other Qualifications", text: qualifications },
        { label: "School Qualification ", text: highestQualification },
    ];
}

export function getFeesSVGLines({
    costs,
    fees,
    otherGrants,
    feesReceipt,
}: FeesData) {
    const lines = [
        { heading: "Financial" },
        { label: "Fees", text: fees },
        { label: "Other Costs", text: costs },
        { label: "Other Grants", text: otherGrants },
    ];

    if (feesReceipt?.length) {
        lines.push({ label: "Fees Receipt", text: feesReceipt[0].name });
    }

    return lines;
}

export function getSchoolSVGLines(data: SchoolData): SVGProcessData {
    const { school, schoolYear } = data;
    if (!school && !schoolYear) {
        return {
            svgLines: [],
            remainingData: (data as unknown) as SVGSourceData,
        };
    }

    const svgLines = [
        { heading: "School" },
        { label: "School", text: school },
        { label: "School Year", text: schoolYear },
    ];

    const { school: _school, schoolYear: _schoolYear, ...remainingData } = data;

    return {
        svgLines,
        remainingData: (remainingData as unknown) as SVGSourceData,
    };
}
